import ReportService from '@/services/report.service'
import TippingService from '@/services/tipping.service'
import store from '@/store'
import { errorNotification } from '@/utils/notification'
import { getColByDay, getColByYear, getColByMonth, getColByWeek } from '@/utils/date'
import { forLoop } from '@/utils/awaitLoop'
import modeQuery from '@/constants/modeQuery'
import reportType from '@/config/reportType'

export default {
  getReportDataByStore ({ commit, state }, payload) {
    payload.query = { ...state.query, ...payload.query }
    if (state?.currentPath && window.location.pathname !== state?.currentPath) {
      payload.query = { ...payload.query, ...state.query, page: 1, productCategoryId: payload.query.productCategoryId === null ? null : state.query.productCategoryId, mode: payload.query.mode === state.query.mode ? state.query.mode : payload.query.mode }
    } else {
      payload.query = { ...state.query, ...payload.query, outletIds: !!state.query?.outletIds && !payload.query?.outletIds && state.query?.registerIds?.length && payload.query?.registerIds?.length && state.query?.registerIds === payload.query?.registerIds ? state.query.outletIds : payload.query.outletIds }
    }
    if (payload.query.productCategoryId === 'Uncategorized') {
      payload.query.productCategoryId = 'uncategorized'
    }
    if (payload.type === 'product-profit' || payload.type === 'product-sold') {
      payload.query = { ...payload.query, states: '', statuses: '' }
    }
    if (reportType.usePaginations.includes(payload.type) && !payload?.isExportExcel) {
      payload.query = { ...payload.query, limit: 20 }
    } else {
      payload.query = { ...payload.query, limit: 100 }
    }
    const _store = store
    commit('SET_LOADING_REPORT', true)
    commit('SET_QUERY_REPORT', { type: payload.type, query: payload.query, currentPath: window.location.pathname })
    return ReportService.getReportByStore(payload.type, payload.query, store)
      .then(store => {
        if (store) {
          if (reportType.usePaginations.includes(payload.type)) {
            if (payload?.isExportExcel) {
              var pages = []
              let reportData = store.data?.items || []
              for (let i = 1; i < store.data.maxPage; i++) {
                pages.push(i + 1)
              }
              return Promise.all(pages.map(page => ReportService.getReportByStore(payload.type, { ...payload.query, page: page }, _store, null, true)))
                .then(results => {
                  for (let index = 0; index < results.length; index++) {
                    if (results[index]?.data?.items) {
                      reportData = [...reportData, ...results[index]?.data?.items]
                    }
                  }
                  commit('SET_LIST_REPORT', { query: payload.query, report: reportData, type: payload.type, fillter_type: payload.query.mode, count_items: store.data.countItems })
                  commit('SET_LOADING_REPORT', false)
                })
                .catch(() => {
                  commit('SET_LOADING_REPORT', false)
                })
            }
            commit('SET_LIST_REPORT', { query: payload.query, report: store.data.items || [], type: payload.type, fillter_type: payload.query.mode, count_items: store.data.countItems })
            commit('SET_LOADING_REPORT', false)
          } else {
            let reportData = store.data.items || []
            if (store.data.maxPage > 1) {
              forLoop(store.data.maxPage - 1, ReportService.getReportByStore, payload.type, payload.query)
                .then(data => {
                  reportData = [...reportData, ...data]
                  commit('SET_LIST_REPORT', { query: payload.query, report: reportData, type: payload.type, fillter_type: payload.query.mode })
                  commit('SET_LOADING_REPORT', false)
                })
                .catch(() => {})
            } else {
              commit('SET_LIST_REPORT', { query: payload.query, report: reportData, type: payload.type, fillter_type: payload.query.mode })
              commit('SET_LOADING_REPORT', false)
            }
          }
        } else {
          commit('SET_LIST_REPORT', { query: payload.query, report: [], type: payload.type, fillter_type: payload.query.mode })
          commit('SET_LOADING_REPORT', false)
        }
      })
      .catch(error => errorNotification(error.message))
  },
  getSalesOrderByStore ({ commit, state }, payload) {
    payload.query = { ...state.query, ...payload.query }
    if (state?.currentPath && window.location.pathname !== state?.currentPath) {
      payload.query = { ...payload.query, ...state.query, page: 1, productCategoryId: payload.query.productCategoryId === null ? null : state.query.productCategoryId, mode: payload.query.mode === state.query.mode ? state.query.mode : payload.query.mode }
    } else {
      payload.query = { ...state.query, ...payload.query, outletIds: !!state.query?.outletIds && !payload.query?.outletIds && state.query?.registerIds?.length && payload.query?.registerIds?.length && state.query?.registerIds === payload.query?.registerIds ? state.query.outletIds : payload.query.outletIds }
    }
    payload.query = { ...payload.query, limit: 100 }
    const _store = store
    commit('SET_LOADING_REPORT', true)
    return ReportService.getReportByStore('orders', payload.query, store)
      .then(store => {
        if (store) {
          if (payload?.isExportExcel) {
            var pages = []
            let reportData = store.data?.items || []
            for (let i = 1; i < store.data.maxPage; i++) {
              pages.push(i + 1)
            }
            return Promise.all(pages.map(page => ReportService.getReportByStore('orders', { ...payload.query, page: page }, _store, null, true)))
              .then(results => {
                for (let index = 0; index < results.length; index++) {
                  if (results[index]?.data?.items) {
                    reportData = [...reportData, ...results[index]?.data?.items]
                  }
                }
                commit('SET_LIST_SALES_ORDER', { query: payload.query, salesOrderData: reportData, type: 'orders', fillter_type: payload.query.mode, count_items: store.data.countItems })
                commit('SET_LOADING_REPORT', false)
                _store.commit('common/SET_LOADING', false)
              })
              .catch(() => {
                commit('SET_LOADING_REPORT', false)
                _store.commit('common/SET_LOADING', false)
              })
          }
        } else {
          commit('SET_LIST_SALES_ORDER', { query: payload.query, salesOrderData: [], type: 'orders', fillter_type: payload.query.mode })
          commit('SET_LOADING_REPORT', false)
          _store.commit('common/SET_LOADING', false)
        }
      })
      .catch(error => errorNotification(error.message))
  },
  getTippingReportDataByStore ({ commit, state }, payload) {
    if (!payload?.isExportExcel) {
      payload.query = { ...payload.query, limit: 20 }
    } else {
      payload.query = { ...payload.query, limit: 100 }
    }
    payload.query = { ...state.query, ...payload.query }
    commit('SET_LOADING_REPORT', true)
    commit('SET_QUERY_REPORT', { type: payload.type, query: payload.query, currentPath: window.location.pathname })
    var _store = store
    return TippingService.getTippingTransaction(payload.query, store)
      .then(store => {
        if (store) {
          if (payload?.isExportExcel) {
            var pages = []
            let reportData = store.data?.items || []
            for (let i = 1; i < store.data.maxPage; i++) {
              pages.push(i + 1)
            }
            return Promise.all(pages.map(page => TippingService.getTippingTransaction({ ...payload.query, page: page }, _store)))
              .then(results => {
                for (let index = 0; index < results.length; index++) {
                  if (results[index]?.data?.items) {
                    reportData = [...reportData, ...results[index]?.data?.items]
                  }
                }
                commit('SET_TIPPING_DATA', { query: payload.query, report: reportData, type: payload.type, fillter_type: payload.query.mode, count_items: store.data.countItems })
                commit('SET_LOADING_REPORT', false)
              })
              .catch(() => {
                commit('SET_LOADING_REPORT', false)
              })
          } else {
            commit('SET_TIPPING_DATA', { query: payload.query, report: store.data.items || [], type: payload.type, fillter_type: payload.query.mode, count_items: store.data.countItems })
            commit('SET_LOADING_REPORT', false)
          }
        } else {
          commit('SET_TIPPING_DATA', { query: payload.query, report: [], type: payload.type, fillter_type: payload.query.mode })
          commit('SET_LOADING_REPORT', false)
        }
      })
      .catch(error => errorNotification(error.message))
  },
  getTippingReportSummary ({ commit, state }, payload) {
    payload.query = { ...state.query, ...payload.query }
    commit('SET_LOADING_REPORT', true)
    commit('SET_QUERY_REPORT', { type: payload.type, query: payload.query, currentPath: window.location.pathname })
    var _store = store
    return TippingService.getTippingSummary(payload.query, store)
      .then(store => {
        if (store) {
          var pages = []
          let reportData = store.data?.items || []
          for (let i = 1; i < store.data.maxPage; i++) {
            pages.push(i + 1)
          }
          return Promise.all(pages.map(page => TippingService.getTippingSummary({ ...payload.query, page: page }, _store)))
            .then(results => {
              for (let index = 0; index < results.length; index++) {
                if (results[index]?.data?.items) {
                  reportData = [...reportData, ...results[index]?.data?.items]
                }
              }
              commit('SET_TIPPING_DATA', { query: payload.query, report: reportData, type: 'summary', fillter_type: payload.query.mode, count_items: store.data.countItems })
              commit('SET_LOADING_REPORT', false)
            })
            .catch(() => {
              commit('SET_LOADING_REPORT', false)
            })
        } else {
          commit('SET_TIPPING_DATA', { query: payload.query, report: [], type: 'summary', fillter_type: payload.query.mode })
          commit('SET_LOADING_REPORT', false)
        }
      })
      .catch(error => errorNotification(error.message))
  },
  getOrdersReportSummary ({ commit, state }, payload) {
    payload.query = { ...state.query, ...payload.query }
    return ReportService.getReportByStore(reportType.saleSummary, payload.query, store)
      .then(store => {
        if (store) {
          let reportData = store.data.items || []
          if (store.data.maxPage > 1) {
            forLoop(store.data.maxPage - 1, ReportService.getReportByStore, payload.type, payload.query)
              .then(data => {
                reportData = [...reportData, ...data]
                commit('SET_LIST_REPORT', { query: payload.query, report: reportData, type: payload.type, fillter_type: payload.query.mode })
                commit('SET_LOADING_REPORT', false)
              })
              .catch(() => {})
          } else {
            commit('SET_LIST_REPORT', { query: payload.query, report: reportData, type: payload.type, fillter_type: payload.query.mode })
            commit('SET_LOADING_REPORT', false)
          }
        } else {
          commit('SET_LIST_REPORT_NO_DATA')
          commit('SET_LOADING_REPORT', false)
        }
      })
      .catch(error => errorNotification(error.message))
  },
  getUsers ({ commit }, payload) {
    commit('SET_LOADING_REPORT', true)
    var _store = store
    return TippingService.getUsers(payload, store)
      .then(store => {
        if (store) {
          var pages = []
          let reportData = store.data?.items || []
          for (let i = 1; i < store.data.maxPage; i++) {
            pages.push(i + 1)
          }
          return Promise.all(pages.map(page => TippingService.getUsers({ page: page }, _store)))
            .then(results => {
              for (let index = 0; index < results.length; index++) {
                if (results[index]?.data?.items) {
                  reportData = [...reportData, ...results[index]?.data?.items]
                }
              }
              if (reportData && !!reportData.length) {
                reportData = reportData.filter(data => {
                  return data.status
                })
              }
              commit('SET_SALESPERSONS_DATA', reportData)
              commit('SET_LOADING_REPORT', false)
            })
            .catch(() => {
              commit('SET_LOADING_REPORT', false)
            })
        } else {
          commit('SET_SALESPERSONS_DATA', [])
          commit('SET_LOADING_REPORT', false)
        }
      })
      .catch(error => errorNotification(error.message))
  },
  async getGlobalReport ({ commit }, payload) {
    commit('SET_LOADING_REPORT', true)
    commit('CLEAR_GLOBAL_DATA')
    commit('SET_QUERY_REPORT', { type: reportType.globalReport, query: payload.query })
    const { allOutlets } = payload
    return Promise.all(Object.keys(allOutlets || {}).map(async field => {
      let value
      try {
        if (window.location.pathname === '/global-stores') {
          let storeData
          try {
            storeData = await ReportService.getReportByStore(reportType.saleSummary, { ...payload.query, storeId: field }, store, field)
          } catch (error) {
            errorNotification(error.message)
          }
          if (storeData) {
            let reportData = storeData.data.items || []
            if (storeData.data.maxPage > 1) {
              let data
              try {
                data = await forLoop(storeData.data.maxPage - 1, ReportService.getReportByStore, reportType.saleSummary, { ...payload.query, storeId: field }, field)
              } catch (error) {
                errorNotification(error)
              }
              reportData = [...reportData, ...data]
              commit('SET_GLOBAL_DATA', { report: reportData, fillter_type: payload.query.mode, storeId: field, isGlobalStores: true })
            } else {
              commit('SET_GLOBAL_DATA', { report: reportData, fillter_type: payload.query.mode, storeId: field, isGlobalStores: true })
            }
          } else {
            commit('SET_GLOBAL_DATA', { report: [], fillter_type: payload.query.mode, storeId: field, isGlobalStores: true })
          }
          return storeData
        }
        value = await Promise.all(allOutlets[field].map(async outlet => {
          let storeData
          try {
            storeData = await ReportService.getReportByStore(reportType.saleSummary, { ...payload.query, outletId: outlet.id }, store, field)
          } catch (error) {
            errorNotification(error.message)
          }
          if (storeData) {
            let reportData = storeData.data.items || []
            if (storeData.data.maxPage > 1) {
              let data
              try {
                data = await forLoop(storeData.data.maxPage - 1, ReportService.getReportByStore, reportType.saleSummary, { ...payload.query, outletId: outlet.id }, field)
              } catch (error) {
                errorNotification(error)
              }
              reportData = [...reportData, ...data]
              commit('SET_GLOBAL_DATA', { report: reportData, fillter_type: payload.query.mode, storeId: field, outletId: outlet.id })
            } else {
              commit('SET_GLOBAL_DATA', { report: reportData, fillter_type: payload.query.mode, storeId: field, outletId: outlet.id })
            }
          } else {
            commit('SET_GLOBAL_DATA', { report: [], fillter_type: payload.query.mode, storeId: field, outletId: outlet.id })
          }
          return storeData
        }))
      } catch (error) {}
      return value
    })).then(() => {
      commit('PUBLISH_GLOBAL_REPORT')
      commit('SET_LOADING_REPORT', false)
      store.commit('common/SET_LOADING', false)
    }).catch((error) => {
      commit('SET_LOADING_REPORT', false)
      store.commit('common/SET_LOADING', false)
      errorNotification(error.message)
    })
  },
  changeStoreGetReportData ({ commit, state }) {
    const isDashboard = window.location.pathname === '/dashboard'
    const isGlobal = window.location.pathname === '/global'
    const query = {
      ...state.query,
      page: 1,
      outletId: null,
      outletIds: null,
      registerIds: null
    }
    commit('SET_LOADING_REPORT', true)
    if (isGlobal) {
      return
    } else if (isDashboard) {
      const reportTypes = [reportType.saleSummary, reportType.productSold, reportType.payment]
      return Promise.all([
        ReportService.getReportByStore(reportType.saleSummary, query, store),
        ReportService.getReportByStore(reportType.productSold, query, store),
        ReportService.getReportByStore(reportType.payment, query, store)
      ])
        .then(stores => {
          stores.forEach((store, index) => {
            if (store) {
              let reportData = store.data.items
              if (store.data.maxPage > 1) {
                forLoop(store.data.maxPage - 1, ReportService.getReportByStore, reportTypes[index], query)
                  .then(data => {
                    reportData = [...reportData, ...data]
                    commit('SET_LIST_REPORT', { query: query, report: reportData, type: reportTypes[index], fillter_type: query.mode })
                    commit('SET_QUERY_REPORT', { type: reportTypes[index], query: query })
                    commit('SET_LOADING_REPORT', false)
                  })
                  .catch(error => errorNotification(error))
              } else {
                commit('SET_LIST_REPORT', { query: query, report: reportData, type: reportTypes[index], fillter_type: query.mode })
                commit('SET_QUERY_REPORT', { type: reportTypes[index], query: query })
                commit('SET_LOADING_REPORT', false)
              }
            } else {
              commit('SET_LIST_REPORT_NO_DATA')
              commit('SET_QUERY_REPORT', { type: reportTypes[index], query: query })
              commit('SET_LOADING_REPORT', false)
            }
          })
        })
        .catch(error => errorNotification(error.message))
    }
    if (state.type === reportType.productSold || state.type === reportType.productProfit) {
      delete query.productCategoryId
    }
    if (state.type === reportType.tippings || state.type === undefined) {
      return
    }
    return ReportService.getReportByStore(state.type, query, store)
      .then(store => {
        if (store) {
          let reportData = store.data.items
          if (reportType.usePaginations.includes(state.type)) {
            commit('SET_LIST_REPORT', { query: query, report: store.data.items || [], type: state.type, fillter_type: state.query.mode, count_items: store.data.countItems })
            commit('SET_LOADING_REPORT', false)
          } else {
            if (store.data.maxPage > 1) {
              forLoop(store.data.maxPage - 1, ReportService.getReportByStore, state.type, query)
                .then(data => {
                  reportData = [...reportData, ...data]
                  commit('SET_LIST_REPORT', { query: query, report: reportData, type: state.type, fillter_type: query.mode })
                  commit('SET_QUERY_REPORT', { type: state.type, query: query })
                  commit('SET_LOADING_REPORT', false)
                })
                .catch(error => errorNotification(error))
            } else {
              commit('SET_LIST_REPORT', { query: query, report: reportData, type: state.type, fillter_type: query.mode })
              commit('SET_QUERY_REPORT', { type: state.type, query: query })
              commit('SET_LOADING_REPORT', false)
            }
          }
        } else {
          commit('SET_LIST_REPORT_NO_DATA')
          commit('SET_QUERY_REPORT', { type: state.type, query: query })
          commit('SET_LOADING_REPORT', false)
        }
      })
      .catch(error => errorNotification(error.message))
  },
  getColTable ({ commit }, payload) {
    let cols = {}
    if (payload.type === modeQuery.DATE) {
      cols = getColByDay(payload.startDate, payload.range)
    } else if (payload.type === modeQuery.YEAR) {
      cols = getColByYear(payload.startDate, payload.range)
    } else if (payload.type === modeQuery.MONTH) {
      cols = getColByMonth(payload.startDate, payload.range)
    } else if (payload.type === modeQuery.WEEK) {
      cols = getColByWeek(payload.startDate, payload.range)
    } else {
      cols = {}
    }
    commit('SET_COLS_REPORT', cols)
  },
  getProductSoldSumStore ({ commit, state }, payload) {
    payload.query = { ...state.query, ...payload.query }
    if (state?.currentPath && window.location.pathname !== state?.currentPath) {
      payload.query = { ...payload.query, ...state.query, page: 1, productCategoryId: payload.query.productCategoryId === null ? null : state.query.productCategoryId, mode: payload.query.mode === state.query.mode ? state.query.mode : payload.query.mode }
    } else {
      payload.query = { ...state.query, ...payload.query }
    }
    payload.query = { ...payload.query, states: '', statuses: '' }
    if (payload.query.productCategoryId === 'Uncategorized') {
      payload.query.productCategoryId = 'uncategorized'
    }
    commit('SET_LOADING_PRODUCT_SOLD', true)
    const _store = store
    return ReportService.getReportByStore(reportType.productSold, payload.query, store, null, null, true)
      .then(store => {
        if (store) {
          let dataProductSold = store.data?.items || []
          if (store.data?.maxPage > 1) {
            var pages = []
            for (let i = 1; i < store.data.maxPage; i++) {
              pages.push(i + 1)
            }
            return Promise.all(pages.map(page => ReportService.getReportByStore(reportType.productSold, { ...payload.query, page: page }, _store, null, null, true)))
              .then(results => {
                for (let index = 0; index < results.length; index++) {
                  if (results && results[index]?.data?.items) {
                    dataProductSold = [...dataProductSold, ...results[index]?.data?.items]
                  }
                }
                commit('SET_DATA_PRODUCT_SOLD_CHART', { data: dataProductSold })
                commit('SET_LOADING_PRODUCT_SOLD', false)
              })
              .catch((e) => {
                commit('SET_LOADING_PRODUCT_SOLD', false)
              })
          } else {
            commit('SET_DATA_PRODUCT_SOLD_CHART', { data: dataProductSold })
            commit('SET_LOADING_PRODUCT_SOLD', false)
          }
        } else {
          commit('SET_LIST_REPORT', { data: [] })
          commit('SET_LOADING_PRODUCT_SOLD', false)
        }
      })
      .catch(() => {})
  },
  setLoadingReport ({ commit }, loading) {
    commit('SET_LOADING_REPORT', loading)
  },
  setLoadingProductChart ({ commit }, loading) {
    commit('SET_LOADING_PRODUCT_SOLD', loading)
  },
  setDataExcel ({ commit }, payload) {
    commit('SET_EXCEL_DATA_SELL_REPORT', payload)
  },
  setCommonLoading ({ commit }, loading) {
    store.commit('common/SET_LOADING', loading)
  },
  setExportingData ({ commit }, payload) {
    commit('SET_EXPORTING', payload)
  },
  setChangeStore ({ commit }, payload) {
    commit('SET_CHANGE_STORE', payload)
  },
  setCustomizeData ({ commit }, payload) {
    commit('SET_CUSTOMIZE_DATA', payload)
  }
}
